import { scrolltop } from "assets/icons/index";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface ScrollToTopProps {}

const ScrollToTop = ({}: ScrollToTopProps) => {
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      ref={scrollRef}
      onClick={scrollToTop}
      className={`hidden fixed bottom-[8%] left-[5%] z-40 w-[50px] h-[50px] bg-first_color font-${
        i18n.language === "en" ? "Poppins" : "Almarai"
      } font-[600] text-[15px] text-first_color border-[5px] rounded-full border-first_color lg:flex flex-col items-center justify-center cursor-pointer transition-opacity duration-300 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      <img className="max-w-[30px]" src={scrolltop} alt="" />
    </div>
  );
};

export default ScrollToTop;
